import React, { memo } from 'react';
import './demandPlannerSecMat.scss';
import GridTable from './gridTable';

const DemandPlannerSecMatGridTable = memo(({ cotcData, normalData, visibleList, hiddenList, visibleList2, visibleList2Labels, hiddenListLabels, visibleListLabels }) => {

    // let readyToMapNormalData = normalData && Object.entries(normalData[1])

    // let readyToMapCotcData = cotcData && Object.entries(cotcData[1])

    return (

        <div className='dp-sec-mat-table-container'>

            <GridTable
                data={normalData.data}
                visibleList={visibleList}
                visibleListLabels={visibleListLabels}
                hiddenList={hiddenList}
                hiddenListLabels={hiddenListLabels}
                heading={normalData.label}
                visibleList2={visibleList2}
                visibleList2Labels={visibleList2Labels}
            />

            { cotcData &&
                <GridTable
                    data={cotcData.data}
                    visibleList={visibleList}
                    visibleListLabels={visibleListLabels}
                    hiddenList={hiddenList}
                    hiddenListLabels={hiddenListLabels}
                    heading={`${cotcData.label} - COTC`}
                    visibleList2={visibleList2}
                    visibleList2Labels={visibleList2Labels}
                />
            }

        </div>

    );
})

export default DemandPlannerSecMatGridTable;